import { ScrollTop } from '@/components/element/ScrollTop';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { Activities } from '@/features/w/[identifier]/teams/[team_id]/sales_orders/[sales_order_id]/{components}/Activities';
import { Comments } from '@/features/w/[identifier]/teams/[team_id]/sales_orders/[sales_order_id]/{components}/Comments';
import { ContractAlert } from '@/features/w/[identifier]/teams/[team_id]/sales_orders/[sales_order_id]/{components}/ContractAlert';
import { InvoiceTasks } from '@/features/w/[identifier]/teams/[team_id]/sales_orders/[sales_order_id]/{components}/InvoiceTasks';
import { ProjectSummary } from '@/features/w/[identifier]/teams/[team_id]/sales_orders/[sales_order_id]/{components}/ProjectSummary';
import { QuotationTasks } from '@/features/w/[identifier]/teams/[team_id]/sales_orders/[sales_order_id]/{components}/QuotationTasks';
import { RelatedProjects } from '@/features/w/[identifier]/teams/[team_id]/sales_orders/[sales_order_id]/{components}/RelatedProjects';
import { SalesOrderContractTasks } from '@/features/w/[identifier]/teams/[team_id]/sales_orders/[sales_order_id]/{components}/SalesOrderContractTasks';
import { useNavState } from '@/providers/NavStateProvider';
import { useCurrentSalesOrder } from '@/providers/SalesOrderProvider';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useEffect } from 'react';
import { SalesOrderPL } from '@/features/w/[identifier]/teams/[team_id]/sales_orders/[sales_order_id]/{components}/SalesOrderPL';

export const TeamSalesOrder = () => {
  const { setTitle, setBreadcrumbs } = useNavState();
  const { _w_, _t_ } = useCurrentTeamMember();
  const { _so_ } = useCurrentSalesOrder();

  useEffect(() => setTitle(`プロジェクト（売上）詳細`), []);
  useEffect(
    () =>
      setBreadcrumbs([
        { label: `プロジェクト（売上） - ${_t_!.name}`, path: `/w/${_w_!.identifier}/teams/${_t_!.id}/sales_orders` },
      ]),
    []
  );

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <div className="container-fluid py-4">
        <ContractAlert />

        <div className="row mb-4">
          <div className="col-12 col-lg-5">
            <ProjectSummary />

            <QuotationTasks />

            <SalesOrderContractTasks />

            <InvoiceTasks />

            <Activities />
          </div>
          <div className="col-12 col-lg-7">
            <Comments />

            {/*<RelatedProjects />*/}

            <SalesOrderPL />
          </div>
        </div>
      </div>
    </WorkspaceLayout>
  );
};
